import * as React from 'react';
import { JSX } from 'react/jsx-runtime';

const HamBurgerIcons = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  const { fill = '#111928', ...rest } = props;

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M22.5 11.1797H11.7375C11.2875 11.1797 10.875 11.5547 10.875 12.0422C10.875 12.4922 11.25 12.9047 11.7375 12.9047H22.5C22.95 12.9047 23.3625 12.5297 23.3625 12.0422C23.3625 11.5547 22.95 11.1797 22.5 11.1797Z"
        fill={fill}
      />
      <path
        d="M22.4992 17.5547H1.49922C1.04922 17.5547 0.636719 17.9297 0.636719 18.4172C0.636719 18.9047 1.01172 19.2797 1.49922 19.2797H22.4992C22.9492 19.2797 23.3617 18.9047 23.3617 18.4172C23.3617 17.9297 22.9492 17.5547 22.4992 17.5547Z"
        fill={fill}
      />
      <path
        d="M1.49922 6.45156H22.4992C22.9492 6.45156 23.3617 6.07656 23.3617 5.58906C23.3617 5.10156 22.9867 4.72656 22.4992 4.72656H1.49922C1.04922 4.72656 0.636719 5.10156 0.636719 5.58906C0.636719 6.07656 1.04922 6.45156 1.49922 6.45156Z"
        fill={fill}
      />
    </svg>
  );
};

export default HamBurgerIcons;
